<template>
  <div>
    <div class="grid-content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>员工模块</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: 'employeeList' }">员工列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: 'employeeWorkload',query:{...backData} }">员工工作量</el-breadcrumb-item>
        <el-breadcrumb-item>工作量详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row :gutter="0"
            class="grid-content">
      <el-col :span="12">
        <div class="inputDiv">
          <div class="inputLeft">员工姓名：</div>
          <el-input v-model="work.staffName"
                    :disabled="true"
                    class="inputRight"
                    style="width: unset;"
                    placeholder="请输入员工姓名"></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">时间:</span>
          <el-date-picker v-model="work.workDate"
                          :disabled="true"
                          type="date"
                          style="width:200px"
                          placeholder="选择日期">
          </el-date-picker>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">批次：</div>
          <el-input v-model="work.batchName"
                    :disabled="true"
                    class="inputRight"
                    style="width: unset;"></el-input>
          <!-- <span class="inputLeft">批次：</span>
          <el-select v-model="work.batchName"
                     style="width:200px"
                     filterable
                     :disabled="true"
                     placeholder="请选择批次">
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select> -->
        </div>

        <div class="inputDiv">
          <div class="inputLeft">工序：</div>
          <el-input v-model="work.processName"
                    :disabled="true"
                    class="inputRight"
                    style="width: unset;"></el-input>
          <!-- <span class="inputLeft">工序：</span>
          <el-select v-model="value"
                     filterable
                     :disabled="true"
                     style="width:200px"
                     placeholder="请选择工序">
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select> -->
        </div>
        <div class="inputDiv">
          <div class="inputLeft">单件：</div>
          <div class="inputRight" style="width: 194.2px;">{{work.unitPrice}}(元)</div>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">完成件数：</div>
          <el-input v-model="work.amount"
                    :disabled="inputDisabled"
                    @input="inputAmount"
                    type="number"
                    class="inputRight"
                    style="width: unset;"
                    placeholder="请输入完成件数"></el-input>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">总价：</div>
          <div class="inputRight" style="width: 194.2px;">{{work.salary}}(元)</div>
        </div>
        <div class="inputDiv">
          <el-button type="primary"
                     @click="onEdit"
                     class="widthButton">{{edit}}</el-button>
          <el-button class="widthButton"
                     @click="back">取消</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { workRecordMod } from "@/api/workRecord";
export default {
  data() {
    return {
      inputDisabled: true,
      edit: "编辑",
      backData: {},
      work: {}
    };
  },
  mounted() {
    this.backData = {
      staffName: this.$route.query.staffName,
      id: this.$route.query.id,
      tel: this.$route.query.tel,
      month: this.$route.query.month
    };
    this.work = this.$route.query.work;
  },
  methods: {
    onEdit() {
      if (this.inputDisabled) {
        this.inputDisabled = false;
        this.edit = "确定";
      } else {
        this.modWork();
      }
    },
    inputAmount() {
      this.work.salary = (this.work.unitPrice * this.work.amount).toFixed(4);
    },
    back() {
      this.$router.go(-1);
    },
    modWork() {
      const params = {
        id: this.work.id,
        userId: this.work.userId,
        workDate: this.work.workDate,
        batchId: this.work.batchId,
        processId: this.work.processId,
        amount: this.work.amount
      };
      workRecordMod(params)
        .then(res => {
          console.log(res);
          
            this.inputDisabled = true;
            this.edit = "编辑";
            this.$message({
              type: "success",
              message: "修改成功!"
            });
            this.back();
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style>
</style>
